var _rect, _path, _rect2, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconmp4 = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#5E35B1",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.414 6H10C8.897 6 8 6.898 8 8V24C8 25.103 8.897 26 10 26H22C23.103 26 24 25.103 24 24V10.586L19.414 6ZM11 16H19V18H11V16ZM21 22H11V20H21V22ZM18 12V7L23 12H18Z",
    fill: "#5E35B1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 12,
    height: 8,
    fill: "#5E35B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7155 18.3636H11.6636L12.665 20.8068H12.7077L13.7091 18.3636H14.6572V22H13.9115V19.6332H13.8813L12.9403 21.9822H12.4324L11.4914 19.6243H11.4612V22H10.7155V18.3636ZM15.2907 22V18.3636H16.7253C17.0011 18.3636 17.2361 18.4163 17.4302 18.5217C17.6243 18.6258 17.7723 18.7708 17.8741 18.9567C17.9771 19.1413 18.0286 19.3544 18.0286 19.5959C18.0286 19.8374 17.9765 20.0504 17.8723 20.2351C17.7682 20.4197 17.6172 20.5636 17.4196 20.6665C17.2231 20.7695 16.9851 20.821 16.7058 20.821H15.7914V20.2049H16.5815C16.7295 20.2049 16.8514 20.1795 16.9473 20.1286C17.0443 20.0765 17.1165 20.0049 17.1639 19.9137C17.2124 19.8214 17.2367 19.7154 17.2367 19.5959C17.2367 19.4751 17.2124 19.3698 17.1639 19.2798C17.1165 19.1887 17.0443 19.1183 16.9473 19.0685C16.8502 19.0176 16.7271 18.9922 16.5779 18.9922H16.0595V22H15.2907ZM18.4516 21.3608V20.7553L19.9697 18.3636H20.4917V19.2017H20.1828L19.2258 20.7163V20.7447H21.3831V21.3608H18.4516ZM20.197 22V21.1761L20.2112 20.908V18.3636H20.9321V22H20.197Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconmp4, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconmp4.9079658a.svg";
export { ForwardRef as ReactComponent };